import toCamelCase from "./snakeCaseToCamelCase";

const snakeCaseToCamelCaseObjectKeys = (obj: object) => {
  const entries = Object.entries(obj);
  const camelEntries = entries.map(([key, value]) => [toCamelCase(key), value]);
  return Object.fromEntries(camelEntries);
};

export default snakeCaseToCamelCaseObjectKeys;
